module.exports = __webpack_public_path__ + "static/media/pr-12.1004ff98.jpeg";